import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuStylingOption} from '@Components/contextual-menu/components/contextual-menu-styling-option';
import {AnimatePresence, motion} from 'framer-motion';

export function PageUnlockAllItemsOption(): ReactElement<any> | null {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  const onClickHandler = (): void => {
    currentPage?.items.unLockAllLockedItems();
  };

  return (
    <AnimatePresence initial={false}>
      {currentPage && currentPage.items.hasLockedItems() ? (
        <motion.div layout initial={{height: 0}} animate={{height: 'auto'}} transition={{duration: 0.2}} exit={{height: 0}}>
          <ContextualMenuStylingOption
            id="unlock-all-items-option"
            onClick={onClickHandler}
            label={window.i18next.t('pmwjs_unlock_all')}
            data={[
              {
                id: 'unlock-option',
                icon: 'icon-unlock',
              },
            ]}
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
